import PropTypes from 'prop-types';
import React from 'react';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import translate from '../../commonComponents/translate';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import { useSanitize } from '../../services/customHooks';

function CancellationPolicy(props) {
  const { t, cancellationPolicy } = props;
  const cancellation = useSanitize(cancellationPolicy);

  return (
    <Title title={t('landing.cancellation.policy')}>
      <ContentContainer>
        <SubHeader title={t('landing.cancellation.policy')} />
        <div className="m-content">
          <div className="row full-page-container">
            <div
              className="container bg-white pt-2"
              dangerouslySetInnerHTML={{
                __html: cancellation,
              }}
            />
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

CancellationPolicy.propTypes = {
  t: PropTypes.func.isRequired,
  cancellationPolicy: PropTypes.string.isRequired,
};

export default translate(CancellationPolicy);
